import type { ADNode } from '@atlaskit/editor-common/validator';

import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';
import { extensionToADF } from '@confluence/fabric-extension-lib/entry-points/editor-extensions.ts';

import { serializeExtensionADF } from './serializeExtensionADF.ts';

const getContentId = (adf: ADNode, contentId: string) => {
	const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
	return parentId || contentId;
};

type MacroQueryParams = {
	adf?: ADNode;
	node?: any;
	mode?: string;
	contentId: string;
};

export const getMacroQueryVariables = ({
	adf,
	node,
	mode = 'RENDERER',
	contentId,
}: MacroQueryParams) => {
	const extensionADF = adf || extensionToADF(node);
	const isMacroContentAndBody = StatsigConfigurations.getBoolean(
		'confluence_frontend_macro_adf_frontend_render',
		true,
	);

	return {
		adf: serializeExtensionADF(extensionADF),
		mode: mode.toUpperCase(),
		contentId: isMacroContentAndBody ? getContentId(extensionADF, contentId) : contentId,
		isMacroContentAndBody,
	};
};
